import {
  FileSpreadsheet, FileText, FileType, Image as ImageIcon, Table, DraftingCompass,
} from 'lucide-react';

/**
 * Anzeigehelfer für das Dokumente-Modul (bewusst lokale Kopie der
 * rechnungen-Muster — Cross-Modul-Kopplung über gridCells vermeiden;
 * einzig die generische Lightbox wird aus rechnungen importiert).
 */

export type DocumentMimeGroup = 'image' | 'pdf' | 'sheet' | 'document' | 'cad' | 'other';

export const documentMimeGroup = (mime: string | null, name: string | null): DocumentMimeGroup => {
  const m = (mime ?? '').toLowerCase();
  if (m.startsWith('image/')) return 'image';
  if (m.includes('pdf')) return 'pdf';
  // CAD-Planung (DXF/DWG): finfo-snifft text/plain bzw. octet-stream —
  // Endung ist hier das zuverlässige Signal (Server prüft Magic-Bytes).
  if (/\.(dxf|dwg)$/i.test(name ?? '')) return 'cad';
  if (m.includes('spreadsheet') || m.includes('ms-excel') || /\.(xlsx?|csv)$/i.test(name ?? '')) return 'sheet';
  if (m.includes('wordprocessing') || m.includes('msword') || /\.docx?$/i.test(name ?? '')) return 'document';
  return 'other';
};

export const documentGroupIcon: Record<DocumentMimeGroup, typeof FileText> = {
  image: ImageIcon,
  pdf: FileText,
  sheet: FileSpreadsheet,
  document: FileType,
  cad: DraftingCompass,
  other: Table,
};

export const formatFileSize = (bytes: number | null): string => {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** Allowlist = FileStorageService COMMON_MIMES + CAD_EXTENSIONS
 *  (.dxf/.dwg — nur im Dokumente-Store erlaubt). */
export const DOCUMENT_ACCEPT =
  'application/pdf,image/jpeg,image/png,image/gif,image/webp,' +
  'text/csv,text/plain,' +
  'application/vnd.ms-excel,' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/msword,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  '.dxf,.dwg';